import { render, staticRenderFns } from "./CoinsUt.vue?vue&type=template&id=8b688b6c"
import script from "./CoinsUt.vue?vue&type=script&lang=js"
export * from "./CoinsUt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_96d752b47867f79276f3481e194d61e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports